import {Text, Link} from "@gs-ux-uitoolkit-react/text";
import {Form, FormFeedback, FormControl} from "@gs-ux-uitoolkit-react/form";
import {Input} from "@gs-ux-uitoolkit-react/input";
import {Button} from "@gs-ux-uitoolkit-react/button";
import React, {useState} from "react";
import {LoadingIcon} from "@gs-ux-uitoolkit-react/loading";
import {Checkbox} from '@gs-ux-uitoolkit-react/checkbox';

interface PasswordFormProps {
    username: string;
    onSubmit: (password: string, rememberMe: boolean) => Promise<void>;
    onBack: () => void;
    disabled?: boolean;
}

export function PasswordForm({username, onSubmit, onBack, disabled = false}: PasswordFormProps) {
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(localStorage.getItem('rememberMe') === 'true');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);

    const handleSubmit = async () => {
        if (!password) {
            setError('Password is required');
            return;
        }
        setError('');
        setBusy(true);
        try {
            await onSubmit(password, rememberMe);
            localStorage.setItem('rememberMe', rememberMe.toString());
        } finally {
            setBusy(false);
        }
    };

    const isDisabled = disabled || busy;

    return (
        <div className="flex flex-col items-stretch gap-6 w-full">
            <div className="flex flex-row items-baseline justify-between w-full gap-3">
                <Text typography="textTitle02" data-qa-comp="sign-in-title">Sign in</Text>
                <span className="cursor-pointer text-sm" style={{ color: 'rgb(68, 110, 166)' }} onClick={onBack} data-qa-comp="change-username-link">Not you? Change username</span>
            </div>
            <Form className="flex flex-col gap-3 w-full" onSubmit={e => { e.preventDefault(); handleSubmit(); }}>
                <FormControl status={error ? 'error' : 'none'}>
                    <Input
                        autoFocus
                        name="password"
                        type="password"
                        size="md"
                        emphasis="regular"
                        label="Enter Password"
                        className="w-full"
                        disabled={isDisabled}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                        value={password}
                        data-qa-comp="password-input"
                    />
                    <FormFeedback>{error}</FormFeedback>
                </FormControl>
            </Form>
            <Button
                className="w-full"
                size="md"
                appearance="highlight"
                emphasis="bold"
                type="submit"
                onClick={handleSubmit}
                disabled={isDisabled}
                data-qa-comp="sign-in-button"
            >
                {!busy ? 'Login' : <LoadingIcon size="sm"/>}
            </Button>
            <div className="flex flex-col items-center w-full py-4">
                <Text typography="textBody03Regular" data-qa-comp="reset-password-link">
                    <Link href="/sign-in/forgot-password" style={{ color: 'rgb(68, 110, 166)' }}>Reset Password</Link>
                </Text>
            </div>
        </div>
    );
}
